import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MessageDetails } from 'src/app/messages/interfaces/MessageDetails';
import{MatDialog} from '@angular/material/dialog'
import { MessageRecepientsComponent } from '../../message-recepients-popup/message-recepients.component';
import { MessagesFacade } from 'src/app/messages/_services/messages.facade';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-message-details',
  templateUrl: './view-message-details.component.html',
  styleUrls: ['./view-message-details.component.scss']
})
export class ViewMessageDetailsComponent implements OnInit, OnDestroy {
  currLang;
  @Input() messageDetails: MessageDetails;

  constructor(
    public dialog: MatDialog,
    private messageFacade: MessagesFacade,
    private globalService: GlobalService,
    private translate: TranslateService,
    private router: Router) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }
  destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  openMessageRecepients() {
    const dialogRef = this.dialog.open(MessageRecepientsComponent, {
      width: '90vw',
      data: this.messageDetails.recipients,
      disableClose: true
    });
  }

  openMessageViewers() {
    let viewers = [];
    viewers = this.messageDetails.recipients.filter((rec: any) => rec.pivot.is_read === 1)
    const dialogRef = this.dialog.open(MessageRecepientsComponent, {
      width: '90vw',
      data: viewers,
      disableClose: true
    });
  }

  duplicateMessage() {
    this.messageFacade.getCurrentMessage$().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.router.navigateByUrl('messages/create-messages', { state: data })
    })
  }

  deleteMessage() {
    this.messageFacade.deleteMessage(this.messageDetails.id).subscribe(res => {
      this.messageFacade.setReloadMessages(true);
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
